export default {
  categories: [
    {
      image: 'https://m.media-amazon.com/images/I/413EoyvC9HL._SL500_.jpg',
      displayName: 'Machines a cafe grain',
      slug: 'machines-a-cafe-grain',
    },
    {
      image: 'https://m.media-amazon.com/images/I/41hzwM3LtzL._SL500_.jpg',
      displayName: 'Telephones samsung',
      slug: 'telephones-samsung',
    },
    {
      image: 'https://m.media-amazon.com/images/I/417xQG8cG9L._SL500_.jpg',
      displayName: 'Imprimantes 3d',
      slug: 'imprimantes-3d',
    },
    {
      image: 'https://m.media-amazon.com/images/I/41dqLyEO9PL._SL500_.jpg',
      displayName: 'Liseuses',
      slug: 'liseuses',
    },
    {
      image: 'https://m.media-amazon.com/images/I/41Vs6R2QYgL._SL500_.jpg',
      displayName: 'Robots aspirateurs',
      slug: 'robots-aspirateurs',
    },
  ],
  popularCategories: ({device = 'desktop'}: {device: 'desktop' | 'mobile'}) => [
    {
      image: `https://dt47coepsakuj.cloudfront.net/images/${device}/categories-vacuums-floor-care.png`,
      title: 'Vacuums & Floor Care',
      categories: [
        {title: 'Robotic Vacuums', href: '/robotic-vacuums'},
        {title: 'Upright Vacuums', href: '/upright-vacuums'},
        {title: 'Steam Mops', href: '/vacuum-mops'},
        {title: 'Handheld Vacuums', href: '/handheld-vacuums'},
      ],
    },
    {
      image: `https://dt47coepsakuj.cloudfront.net/images/${device}/categories-computers-accessories.png`,
      title: 'Computers & Accessories',
      categories: [
        {title: 'Laptops', href: '/laptops'},
        {title: 'Gaming Laptops', href: '/gaming-laptops'},
        {title: 'Cable Modem', href: '/cable-modem'},
        {title: 'Dell Laptops', href: '/dell-laptops'},
      ],
    },
    {
      image: `https://dt47coepsakuj.cloudfront.net/images/${device}/categories-outdoor-recreation.png`,
      title: 'Outdoor Recreation',
      categories: [
        {title: 'Inflatable Paddle Boards', href: '/inflatable-paddle-boards'},
        {title: 'Instant Tents', href: '/instant-tents'},
        {title: 'Beach Chairs', href: '/beach-chairs'},
        {title: 'Cooler Like Yeti', href: '/cooler-like-yeti'},
      ],
    },
    {
      image: `https://dt47coepsakuj.cloudfront.net/images/${device}/categrories-television-video.png`,
      title: 'Television & Video',
      categories: [
        {title: 'Roku Devices', href: '/roku-devices'},
        {title: '55 inch TVs', href: '/55-inch-tvs'},
        {title: '43 inch TVs', href: '/43-inch-tvs'},
        {title: '32 inch Smart TVs', href: '/32-inch-smart-tvs'},
      ],
    },
  ],
}
